//----------------------  以下由程序自动生成  --------------------------
//-- 作者：cz
//-- 创建时间：2021-12-15 09:02:29
//-- 功能：字典项维护

const dictInfo = {
  Province: [
    { text: '北京市', value: 'BeiJingShi' },
    { text: '天津市', value: 'TianJinShi' },
    { text: '河北省', value: 'HeBeiSheng' },
    { text: '山西省', value: 'ShanXiSheng' },
    { text: '内蒙古自治区', value: 'NeiMengGuZiZhiQu' },
    { text: '辽宁省', value: 'LiaoNingSheng' },
    { text: '吉林省', value: 'JiLinSheng' },
    { text: '黑龙江省', value: 'HeiLongJiangSheng' },
    { text: '上海市', value: 'ShangHaiShi' },
    { text: '江苏省', value: 'JiangSuSheng' },
    { text: '浙江省', value: 'ZheJiangSheng' },
    { text: '安徽省', value: 'AnHuiSheng' },
    { text: '福建省', value: 'FuJianSheng' },
    { text: '江西省', value: 'JiangXiSheng' },
    { text: '山东省', value: 'ShanDongSheng' },
    { text: '河南省', value: 'HeNanSheng' },
    { text: '湖北省', value: 'HuBeiSheng' },
    { text: '湖南省', value: 'HuNanSheng' },
    { text: '广东省', value: 'GuangDongSheng' },
    { text: '广西壮族自治区', value: 'GuangXiZhuangZuZiZhiQu' },
    { text: '海南省', value: 'HaiNanSheng' },
    { text: '重庆市', value: 'ChongQingShi' },
    { text: '四川省', value: 'SiChuanSheng' },
    { text: '贵州省', value: 'GuiZhouSheng' },
    { text: '云南省', value: 'YunNanSheng' },
    { text: '西藏自治区', value: 'XiCangZiZhiQu' },
    { text: '陕西省', value: 'ShanXiShengB' },
    { text: '甘肃省', value: 'GanSuSheng' },
    { text: '青海省', value: 'QingHaiSheng' },
    { text: '宁夏回族自治区', value: 'NingXiaHuiZuZiZhiQu' },
    { text: '新疆维吾尔自治区', value: 'XinJiangWeiWuErZiZhiQu' },
    { text: '台湾省', value: 'TaiWanSheng' },
    { text: '香港特别行政区', value: 'XiangGangTeBieXingZhengQu' },
    { text: '澳门特别行政区', value: 'AoMenTeBieXingZhengQu' },
    { text: '海外', value: 'Overseas' }
  ],
  Overseas: [{ text: '海外', value: 'Overseas' }],
  BeiJingShi: [{ text: '北京市', value: 'BeiJingShi' }],
  TianJinShi: [{ text: '天津市', value: 'TianJinShi' }],
  ShangHaiShi: [{ text: '上海市', value: 'ShangHaiShi' }],
  ChongQingShi: [{ text: '重庆市', value: 'ChongQingShi' }],
  HeBeiSheng: [
    { text: '石家庄市', value: 'ShiJiaZhuangShi' },
    { text: '唐山市', value: 'TangShanShi' },
    { text: '秦皇岛市', value: 'QinHuangDaoShi' },
    { text: '邯郸市', value: 'HanDanShi' },
    { text: '邢台市', value: 'XingTaiShi' },
    { text: '保定市', value: 'BaoDingShi' },
    { text: '张家口市', value: 'ZhangJiaKouShi' },
    { text: '承德市', value: 'ChengDeShi' },
    { text: '沧州市', value: 'CangZhouShi' },
    { text: '衡水市', value: 'HenShuiShi' }
  ],
  ShanXiSheng: [
    { text: '太原市', value: 'TaiYuanShi' },
    { text: '大同市', value: 'DaTongShi' },
    { text: '阳泉市', value: 'YangQuanShi' },
    { text: '长治市', value: 'ChangZhiShi' },
    { text: '晋城市', value: 'JinChengShi' },
    { text: '朔州市', value: 'ShuoZhouShi' },
    { text: '晋中市', value: 'JinZhongShi' },
    { text: '运城市', value: 'YunChengShi' },
    { text: '忻州市', value: 'XinZhouShi' },
    { text: '吕梁市', value: 'LvLiangShi' },
    { text: '临汾市', value: 'LinfenShi' }
  ],
  NeiMengGuZiZhiQu: [
    { text: '呼和浩特市', value: 'HuHeHaoTeShi' },
    { text: '包头市', value: 'BaoTouShi' },
    { text: '乌海市', value: 'WuHaiShi' },
    { text: '赤峰市', value: 'ChiFengShi' },
    { text: '通辽市', value: 'TongLiaoShi' },
    { text: '鄂尔多斯市', value: 'EErDuoSiShi' },
    { text: '呼伦贝尔市', value: 'HuLunBeiErShi' },
    { text: '巴彦淖尔市', value: 'BaYanNaoErShi' }
  ],
  LiaoNingSheng: [
    { text: '沈阳市', value: 'ShenYangShi' },
    { text: '大连市', value: 'DaLianShi' },
    { text: '鞍山市', value: 'AnShanShi' },
    { text: '抚顺市', value: 'FuShunShi' },
    { text: '本溪市', value: 'BenXiShi' },
    { text: '丹东市', value: 'DanDongShi' },
    { text: '锦州市', value: 'JinZhouShi' },
    { text: '营口市', value: 'YingKouShi' },
    { text: '阜新市', value: 'FuXinShi' },
    { text: '盘锦市', value: 'PanJinShi' },
    { text: '铁岭市', value: 'TieLingShi' },
    { text: '朝阳市', value: 'ChaoYangShi' },
    { text: '辽阳市', value: 'LiaoYangShi' },
    { text: '葫芦岛市', value: 'HuLuDaoShi' }
  ],
  JiLinSheng: [
    { text: '长春市', value: 'ChangChunShi' },
    { text: '吉林市', value: 'JiLinShi' },
    { text: '四平市', value: 'SiPingShi' },
    { text: '辽源市', value: 'LiaoYuanShi' },
    { text: '通化市', value: 'TongHuaShi' },
    { text: '白山市', value: 'BaiShanShi' },
    { text: '松原市', value: 'SongYuanShi' },
    { text: '白城市', value: 'BaiChengShi' }
  ],
  HeiLongJiangSheng: [
    { text: '哈尔滨市', value: 'HaErBinShi' },
    { text: '齐齐哈尔市', value: 'QiQiHaErShi' },
    { text: '鸡西市', value: 'JiXiShi' },
    { text: '鹤岗市', value: 'HeGangShi' },
    { text: '双鸭山市', value: 'ShuangYaShanShi' },
    { text: '大庆市', value: 'DaQingShi' },
    { text: '伊春市', value: 'YiChunShi' },
    { text: '佳木斯市', value: 'JiaMuSiShi' },
    { text: '七台河市', value: 'QiTaiHeShi' },
    { text: '黑河市', value: 'HeiHeShi' },
    { text: '绥化市', value: 'SuiHuaShi' },
    { text: '牡丹江市', value: 'MuDanJiangShi' }
  ],
  JiangSuSheng: [
    { text: '南京市', value: 'NanJingShi' },
    { text: '无锡市', value: 'WuXiShi' },
    { text: '徐州市', value: 'XuZhouShi' },
    { text: '常州市', value: 'ChangZhouShi' },
    { text: '苏州市', value: 'SuZhouShi' },
    { text: '南通市', value: 'NanTongShi' },
    { text: '连云港市', value: 'LianYunGangShi' },
    { text: '淮安市', value: 'HuaiAnShi' },
    { text: '盐城市', value: 'YanChengShi' },
    { text: '扬州市', value: 'YangZhouShi' },
    { text: '镇江市', value: 'ZhenJiangShi' },
    { text: '泰州市', value: 'TaiZhouShi' },
    { text: '宿迁市', value: 'SuQianShi' }
  ],
  ZheJiangSheng: [
    { text: '杭州市', value: 'HangZhouShi' },
    { text: '宁波市', value: 'NingBoShi' },
    { text: '温州市', value: 'WenZhouShi' },
    { text: '嘉兴市', value: 'JiaXinShi' },
    { text: '湖州市', value: 'HuZhouShi' },
    { text: '绍兴市', value: 'ShaoXinShi' },
    { text: '金华市', value: 'JinHuaShi' },
    { text: '衢州市', value: 'QuZhouShi' },
    { text: '舟山市', value: 'ZhouShanShi' },
    { text: '丽水市', value: 'LiShuiShi' },
    { text: '台州市', value: 'TaiZhouShi' }
  ],
  AnHuiSheng: [
    { text: '合肥市', value: 'HeFeiShi' },
    { text: '芜湖市', value: 'WuHuShi' },
    { text: '蚌埠市', value: 'BangBuShi' },
    { text: '淮南市', value: 'HuaiNanShi' },
    { text: '马鞍山市', value: 'MaAnShanShi' },
    { text: '淮北市', value: 'HuaiBeiShi' },
    { text: '铜陵市', value: 'TongLingShi' },
    { text: '安庆市', value: 'AnQingShi' },
    { text: '滁州市', value: 'ChuZhouShi' },
    { text: '阜阳市', value: 'FuYangShi' },
    { text: '宿州市', value: 'SuZhouShi' },
    { text: '六安市', value: 'LiuAnShi' },
    { text: '亳州市', value: 'BoZhouShi' },
    { text: '池州市', value: 'ChiZhouShi' },
    { text: '宣城市', value: 'XuanChengShi' },
    { text: '黄山市', value: 'HuangShanShi' }
  ],
  FuJianSheng: [
    { text: '福州市', value: 'FuZhouShi' },
    { text: '厦门市', value: 'XiaMenShi' },
    { text: '莆田市', value: 'PuTianShi' },
    { text: '三明市', value: 'SanMingShi' },
    { text: '泉州市', value: 'QuanZhouShi' },
    { text: '漳州市', value: 'ZhangZhouShi' },
    { text: '南平市', value: 'NanPingShi' },
    { text: '龙岩市', value: 'LongYanShi' },
    { text: '宁德市', value: 'NingDeShi' }
  ],
  JiangXiSheng: [
    { text: '南昌市', value: 'NanChangShi' },
    { text: '景德镇市', value: 'JingDeZhenShi' },
    { text: '萍乡市', value: 'PingXiangShi' },
    { text: '九江市', value: 'JiuJiangShi' },
    { text: '新余市', value: 'XinYuShi' },
    { text: '鹰潭市', value: 'YingTanShi' },
    { text: '赣州市', value: 'GanZhouShi' },
    { text: '吉安市', value: 'JiAnShi' },
    { text: '宜春市', value: 'YiChunShi' },
    { text: '上饶市', value: 'ShangRaoShi' },
    { text: '抚州市', value: 'FuZhouShi' }
  ],
  ShanDongSheng: [
    { text: '济南市', value: 'JiNanShi' },
    { text: '青岛市', value: 'QingDaoShi' },
    { text: '淄博市', value: 'ZiBoShi' },
    { text: '枣庄市', value: 'ZaoZhuangShi' },
    { text: '东营市', value: 'DongYingShi' },
    { text: '烟台市', value: 'YanTaiShi' },
    { text: '潍坊市', value: 'WeiFangShi' },
    { text: '济宁市', value: 'JiNingShi' },
    { text: '泰安市', value: 'TaiAnShi' },
    { text: '日照市', value: 'RiZhaoShi' },
    { text: '莱芜市', value: 'LaiWuShi' },
    { text: '临沂市', value: 'LinYiShi' },
    { text: '德州市', value: 'DeZhouShi' },
    { text: '聊城市', value: 'LiaoChengShi' },
    { text: '滨州市', value: 'BinZhouShi' },
    { text: '菏泽市', value: 'HeZeShi' },
    { text: '威海市', value: 'WeiHaiShi' }
  ],
  HeNanSheng: [
    { text: '郑州市', value: 'ZhengZhouShi' },
    { text: '开封市', value: 'KaiFengShi' },
    { text: '洛阳市', value: 'LuoYangShi' },
    { text: '平顶山市', value: 'PingDingShanShi' },
    { text: '安阳市', value: 'AnYangShi' },
    { text: '鹤壁市', value: 'HeBiShi' },
    { text: '新乡市', value: 'XinXiangShi' },
    { text: '焦作市', value: 'JiaoZuoShi' },
    { text: '濮阳市', value: 'PuYangShi' },
    { text: '漯河市', value: 'LuoHeShi' },
    { text: '三门峡市', value: 'SanMenXiaShi' },
    { text: '南阳市', value: 'NanYangShi' },
    { text: '商丘市', value: 'ShangQiuShi' },
    { text: '信阳市', value: 'XinYangShi' },
    { text: '周口市', value: 'ZhouKouShi' },
    { text: '驻马店市', value: 'ZhuMaDianShi' },
    { text: '许昌市', value: 'XuChangShi' }
  ],
  HuBeiSheng: [
    { text: '武汉市', value: 'WuHanShi' },
    { text: '黄石市', value: 'HuangShiShi' },
    { text: '十堰市', value: 'ShiYanShi' },
    { text: '宜昌市', value: 'YiChangShi' },
    { text: '襄阳市', value: 'XiangYangShi' },
    { text: '鄂州市', value: 'EZhouShi' },
    { text: '荆门市', value: 'JingMenShi' },
    { text: '孝感市', value: 'XiaoGanShi' },
    { text: '黄冈市', value: 'HuangGangShi' },
    { text: '咸宁市', value: 'XianNingShi' },
    { text: '随州市', value: 'SuiZhouShi' },
    { text: '荆州市', value: 'JinZhouShi' }
  ],
  HuNanSheng: [
    { text: '长沙市', value: 'ChangShaShi' },
    { text: '株洲市', value: 'ZhuZhouShi' },
    { text: '湘潭市', value: 'XiangTanShi' },
    { text: '衡阳市', value: 'HenYangShi' },
    { text: '邵阳市', value: 'ShaoYangShi' },
    { text: '岳阳市', value: 'YueYangShi' },
    { text: '常德市', value: 'ChangDeShi' },
    { text: '张家界市', value: 'ZhangJiaJieShi' },
    { text: '益阳市', value: 'YiYangShi' },
    { text: '永州市', value: 'YongZhouShi' },
    { text: '怀化市', value: 'HuaiHuaShi' },
    { text: '郴州市', value: 'ChenZhouShi' }
  ],
  GuangDongSheng: [
    { text: '广州市', value: 'GuangZhouShi' },
    { text: '韶关市', value: 'ShaoGuanShi' },
    { text: '深圳市', value: 'ShenZhenShi' },
    { text: '珠海市', value: 'ZhuHaiShi' },
    { text: '汕头市', value: 'ShanTouShi' },
    { text: '佛山市', value: 'FoShanShi' },
    { text: '江门市', value: 'JiangMenShi' },
    { text: '湛江市', value: 'ZhanJiangShi' },
    { text: '茂名市', value: 'MaiMingShi' },
    { text: '肇庆市', value: 'ZhaoQingShi' },
    { text: '惠州市', value: 'HuiZhouShi' },
    { text: '梅州市', value: 'MeiZhouShi' },
    { text: '汕尾市', value: 'ShanWeiShi' },
    { text: '河源市', value: 'HeYuanShi' },
    { text: '阳江市', value: 'YangJiangShi' },
    { text: '清远市', value: 'QingYuanShi' },
    { text: '东莞市', value: 'DongWanShi' },
    { text: '潮州市', value: 'ChaoZhouShi' },
    { text: '揭阳市', value: 'JieYangShi' },
    { text: '云浮市', value: 'YunFuShi' },
    { text: '中山市', value: 'ZhongShanShi' }
  ],
  GuangXiZhuangZuZiZhiQu: [
    { text: '南宁市', value: 'NanNingShi' },
    { text: '柳州市', value: 'LiuZhouShi' },
    { text: '桂林市', value: 'GuiLinShi' },
    { text: '梧州市', value: 'WuZhouShi' },
    { text: '北海市', value: 'BeiHaiShi' },
    { text: '防城港市', value: 'FangChengGangShi' },
    { text: '钦州市', value: 'QinZhouShi' },
    { text: '贵港市', value: 'GuiGangShi' },
    { text: '玉林市', value: 'YuLinShi' },
    { text: '贺州市', value: 'HeZhouShi' },
    { text: '河池市', value: 'HeChiShi' },
    { text: '来宾市', value: 'LaiBinShi' },
    { text: '崇左市', value: 'ChongZuoShi' },
    { text: '百色市', value: 'BaiSeShi' }
  ],
  HaiNanSheng: [
    { text: '海口市', value: 'HaiKouShi' },
    { text: '三亚市', value: 'SanYaShi' },
    { text: '儋州市', value: 'Danzhou' },
    { text: '三沙市', value: 'SanShaShi' }
  ],
  SiChuanSheng: [
    { text: '成都市', value: 'ChengDouShi' },
    { text: '自贡市', value: 'ZiGongShi' },
    { text: '攀枝花市', value: 'PanZhiHuaShi' },
    { text: '泸州市', value: 'LuZhouShi' },
    { text: '德阳市', value: 'DeYangShi' },
    { text: '绵阳市', value: 'MianYangShi' },
    { text: '广元市', value: 'GuangYuanShi' },
    { text: '遂宁市', value: 'SuiNingShi' },
    { text: '乐山市', value: 'LeShanShi' },
    { text: '南充市', value: 'NanChongShi' },
    { text: '眉山市', value: 'MeiShanShi' },
    { text: '宜宾市', value: 'YiBinShi' },
    { text: '广安市', value: 'GuangAnShi' },
    { text: '达州市', value: 'DaZhouShi' },
    { text: '雅安市', value: 'YaAnShi' },
    { text: '巴中市', value: 'BaZhongShi' },
    { text: '内江市', value: 'NeiJiangShi' },
    { text: '资阳市', value: 'ZiYangeShi' }
  ],
  GuiZhouSheng: [
    { text: '贵阳市', value: 'GuiYangShi' },
    { text: '六盘水市', value: 'LiuPanShuiShi' },
    { text: '遵义市', value: 'ZunYiShi' },
    { text: '安顺市', value: 'AnShunShi' },
    { text: '毕节市', value: 'BiJieShi' },
    { text: '铜仁市', value: 'TongRenShi' }
  ],
  YunNanSheng: [
    { text: '昆明市', value: 'KunMingShi' },
    { text: '曲靖市', value: 'QuJingShi' },
    { text: '玉溪市', value: 'YuXiShi' },
    { text: '保山市', value: 'BaoShanShi' },
    { text: '昭通市', value: 'ZhaoTongShi' },
    { text: '丽江市', value: 'LiJiangShi' },
    { text: '普洱市', value: 'PuErShi' },
    { text: '临沧市', value: 'LinCangShi' }
  ],
  XiCangZiZhiQu: [
    { text: '拉萨市', value: 'LaSaShi' },
    { text: '昌都市', value: 'ChangDouShi' },
    { text: '山南市', value: 'ShanNanShi' },
    { text: '日喀则市', value: 'RiKaZeShi' },
    { text: '林芝市', value: 'LinZhiShi' }
  ],
  ShanXiShengB: [
    { text: '西安市', value: 'XiAnShi' },
    { text: '铜川市', value: 'TongChuanShi' },
    { text: '宝鸡市', value: 'BaoJiShi' },
    { text: '咸阳市', value: 'XianYangShi' },
    { text: '渭南市', value: 'WeiNanShi' },
    { text: '汉中市', value: 'HanZhongShi' },
    { text: '安康市', value: 'AnKangShi' },
    { text: '商洛市', value: 'ShangLuoShi' },
    { text: '延安市', value: 'YanAnShi' },
    { text: '榆林市', value: 'YuLinShi' }
  ],
  GanSuSheng: [
    { text: '兰州市', value: 'LanZhouShi' },
    { text: '嘉峪关市', value: 'JiaYuGuanShi' },
    { text: '金昌市', value: 'JinChangShi' },
    { text: '白银市', value: 'BaiYinShi' },
    { text: '天水市', value: 'TianShuiShi' },
    { text: '酒泉市', value: 'JiuQuanShi' },
    { text: '张掖市', value: 'ZhangYeShi' },
    { text: '武威市', value: 'WuWeiShi' },
    { text: '定西市', value: 'DingXiShi' },
    { text: '陇南市', value: 'LongNanShi' },
    { text: '平凉市', value: 'PinLiangShi' },
    { text: '庆阳市', value: 'QingYangShi' }
  ],
  QingHaiSheng: [
    { text: '西宁市', value: 'XiNingShi' },
    { text: '海东市', value: 'HaiDongShi' }
  ],
  NingXiaHuiZuZiZhiQu: [
    { text: '银川市', value: 'YinChuanShi' },
    { text: '石嘴山市', value: 'ShiZhuiShanShi' },
    { text: '吴忠市', value: 'WuZhongShi' },
    { text: '固原市', value: 'GuYuanShi' },
    { text: '中卫市', value: 'ZhongWeiShi' }
  ],
  XinJiangWeiWuErZiZhiQu: [
    { text: '乌鲁木齐市', value: 'WuLuMuQiShi' },
    { text: '克拉玛依市', value: 'KeLaMaYiShi' },
    { text: '吐鲁番市', value: 'TuLuFanShi' },
    { text: '哈密市', value: 'HaMiShi' }
  ],
  EnableStatus: [
    { text: '启用', value: 'True' },
    { text: '禁用', value: 'False' }
  ],
  ApprovalTemplateType: [
    { text: '合约开仓审批流程', value: 'CrtOpenApproval' },
    { text: '合约了结审批流程', value: 'CrtCloseApproval' },
    { text: '出入金审批流程', value: 'AcctPassApproval' },
    { text: '确认书审批流程', value: 'TradeConfirmationApproval' },
    { text: '结算单审批流程', value: 'TradeSettlementApproval' },
    { text: '自动点价期货平仓审批流程', value: 'AutoPricingFutuCloseApproval' },
    { text: '资金划转/换汇审批流程', value: 'AcctTransferApproval' }
  ],
  ApprovalStatus: [
    { text: '待流转', value: 'WaitingCirculation' },
    { text: '待审批', value: 'WaitingApprove' },
    { text: '审批通过', value: 'Pass' },
    { text: '审批不通过', value: 'UnPass' },
    { text: '撤销审批', value: 'CancelApprove' },
    { text: '终止审批', value: 'TerminationApprove' }
  ],
  RoleStatus: [
    { text: '启用', value: 'Enable' },
    { text: '禁用', value: 'Disable' }
  ],
  UserStatus: [
    { text: '启用', value: 'Enable' },
    { text: '禁用', value: 'Disable' }
  ],
  DocumentType: [
    { text: '营业执照', value: 'BusinessLicense' },
    { text: '财务报告', value: 'FinancialReports' },
    { text: '其他', value: 'Other' }
  ],
  CTPLongOrShort: [
    { text: '多头', value: 'Long' },
    { text: '空头', value: 'Short' }
  ],
  CTPBuyOrSell: [
    { text: '买入', value: 'Buy' },
    { text: '卖出', value: 'Sell' }
  ],
  CTPOpenOrClose: [
    { text: '开仓', value: 'Open' },
    { text: '平仓', value: 'Close' },
    { text: '强平', value: 'ForceClose' },
    { text: '平今仓', value: 'CloseToday' },
    { text: '平昨仓', value: 'CloseYesterday' }
  ],
  CTPHedgeFlag: [
    { text: '套保', value: 'Hedge' },
    { text: '套利', value: 'Arbitrage' },
    { text: '投机', value: 'Speculation' }
  ],
  YesOrNo: [
    { text: '是', value: 'Yes' },
    { text: '否', value: 'No' }
  ],
  ContractOpenStatus: [
    { text: '开仓', value: 'Open' },
    { text: '部分持仓', value: 'Part' },
    { text: '了结', value: 'Finish' }
  ],
  ContractClosingStatus: [{ text: '完成', value: 'Finish' }],
  ContractBuyOrSell: [
    { text: '采购合同', value: 'ContractBuy' },
    { text: '销售合同', value: 'ContractSell' }
  ],
  DepositAddStatus: [
    { text: '待追缴', value: 'WaitingRecovered' },
    { text: '追缴完成', value: 'FinishRecovered' },
    { text: '放弃追缴', value: 'GiveUpRecovered' },
    { text: '无需追缴', value: 'NonRecovered' }
  ],
  FuturesExchange: [
    { text: '郑州商品交易所', value: 'ZhenZhouFuturesExchange' },
    { text: '大连商品交易所', value: 'DaLianFuturesExchange' },
    { text: '上海商品交易所', value: 'ShangHaiFuturesExchange' }
  ],
  ApprovalListType: [
    { text: '指定用户审批', value: 'UserApproval' },
    { text: '指定角色审批', value: 'RoleApproval' }
  ],
  NoticeStatus: [
    { text: '未发布', value: 'New' },
    { text: '发布', value: 'Publish' },
    { text: '删除', value: 'Delete' }
  ],
  NoticeReadStatus: [
    { text: '未读', value: 'UnRead' },
    { text: '已读', value: 'Read' }
  ],
  NoticeFolderType: [
    { text: '通知文件夹', value: 'NoticeFolder' },
    { text: '知识库文件夹', value: 'KnowledgeFolder' }
  ],
  FileMapStatus: [
    { text: '生效', value: 'New' },
    { text: '删除', value: 'Delete' }
  ],
  UserOrRoleType: [
    { text: '角色', value: 'Role' },
    { text: '用户', value: 'User' }
  ],
  ContractType: [
    { text: '普通合约', value: 'Ordinary' },
    { text: '普通合约-名义本金', value: 'OrdinaryNominal' },
    { text: '自动点价', value: 'AutoPricing' },
    { text: '价差', value: 'Spread' },
    { text: '亚式', value: 'Asian' },
    { text: '鲨鱼鳍', value: 'SharkFin' },
    { text: '掉期', value: 'SwapTrade' },
    { text: '台账合约', value: 'Ledger' },
    { text: '个股-香草', value: 'StockVanilla' },
    { text: '个股-雪球', value: 'StockSnowball' },
    { text: '外盘-香草', value: 'ForeignVanilla' },
    { text: '个股-单鲨', value: 'StockSingleShark' },
    { text: '个股-展期', value: 'StockExtendible' },
    { text: '个股-互换', value: 'InterExchange' },
    { text: '持续看涨', value: 'StockContinueCall' },
    { text: '累购累沽', value: 'AccumulateBuySell' }
  ],
  ContractStatus: [
    { text: '新建', value: 'New' },
    { text: '开仓待审批', value: 'OpenPendingApproval' },
    { text: '开仓审批中', value: 'OpenApproving' },
    { text: '开仓审批不通过', value: 'OpenApprovalUnpass' },
    { text: '存续期', value: 'Duration' },
    { text: '部分了结待审批', value: 'PartClosePendingApproval' },
    { text: '部分了结审批中', value: 'PartCloseApproving' },
    { text: '了结待审批', value: 'ClosePendingApproval' },
    { text: '了结审批中', value: 'CloseApproving' },
    { text: '已了结', value: 'Closed' },
    { text: '已作废', value: 'Deleted' }
  ],
  OptionType: [
    { text: '普通期权', value: 'Vanilla' },
    { text: '普通期权-名义本金', value: 'VanillaNominal' },
    { text: '合成期货', value: 'SyntheticFutures' },
    { text: '自动点价', value: 'AutoPricing' },
    { text: '跨品种价差', value: 'IntercommoditySpread' },
    { text: '月间价差', value: 'CalendarSpread' },
    { text: '亚式期权', value: 'Asian' },
    { text: '鲨鱼鳍期权', value: 'SharkFin' },
    { text: '台账期权', value: 'Ledger' },
    { text: '掉期', value: 'SwapTrade' },
    { text: '个股-香草', value: 'StockVanilla' },
    { text: '个股-雪球', value: 'StockSnowball' },
    { text: '个股-单鲨', value: 'StockSingleShark' },
    { text: '外盘-香草', value: 'ForeignVanilla' },
    { text: '个股-展期', value: 'StockExtendible' },
    { text: '个股-互换', value: 'InterExchange' },
    { text: '持续看涨', value: 'StockContinueCall' },
    { text: '累购累沽', value: 'AccumulateBuySell' }
  ],
  HedgeFlag: [
    { text: '套保', value: 'Hedge' },
    { text: '套利', value: 'Arbitrage' },
    { text: '投机', value: 'Speculation' }
  ],
  HoldType: [
    { text: '多头', value: 'Long' },
    { text: '空头', value: 'Short' }
  ],
  InstrumentProductClass: [
    { text: '期货', value: 'Futures' },
    { text: '期货期权', value: 'Options' },
    { text: '组合', value: 'Combination' },
    { text: '即期', value: 'Spot' },
    { text: '期转现', value: 'EFP' },
    { text: '现货期权', value: 'SpotOption' },
    { text: '股票', value: 'Stocks' },
    { text: '股指期权', value: 'ETFOptions' },
    { text: '外盘期货', value: 'ForeighFutures' }
  ],
  CallOrPut: [
    { text: '看涨', value: 'Call' },
    { text: '看跌', value: 'Put' }
  ],
  BuyOrSell: [
    { text: '买', value: 'Buy' },
    { text: '卖', value: 'Sell' }
  ],
  OpenOrClose: [
    { text: '开仓', value: 'Open' },
    { text: '平仓', value: 'Close' },
    { text: '强平', value: 'ForceClose' },
    { text: '平今仓', value: 'CloseToday' },
    { text: '平昨仓', value: 'CloseYesterday' }
  ],
  ActualOrderStatus: [
    { text: '未知', value: 'Unknown' },
    { text: '未成交还在队列中', value: 'NoTradedQueueing' },
    { text: '未成交不在队列中', value: 'NoTradedNotQueueing' },
    { text: '部分成交还在队列中', value: 'PartTradedQueueing' },
    { text: '部分成交不在队列中', value: 'PartTradedNotQueueing' },
    { text: '全部成交', value: 'AllTraded' },
    { text: '撤单中', value: 'Cancelling' },
    { text: '已经撤单', value: 'Canceled' },
    { text: '尚未触发', value: 'NotTouched' },
    { text: '已触发', value: 'Touched' },
    { text: '提交失败', value: 'SubmitFailed' },
    { text: '提交成功', value: 'Submitted' }
  ],
  WarrantWay: [
    { text: '美式行权', value: 'American' },
    { text: '欧式行权', value: 'European' }
  ],
  ClosingType: [
    { text: '期权平仓', value: 'OptionClose' },
    { text: '期权行权', value: 'OptionExercise' },
    { text: '期权到期', value: 'OptionExpire' },
    { text: '期权敲出', value: 'OptionKnockOut' }
  ],
  ClosingStatus: [
    { text: '审批中', value: 'Approving' },
    { text: '审批通过', value: 'Pass' },
    { text: '审批不通过', value: 'UnPass' },
    { text: '撤销审批', value: 'CancelApprove' }
  ],
  OptionStatus: [
    { text: '存续期', value: 'Duration' },
    { text: '部分了结', value: 'PartClosed' },
    { text: '已了结', value: 'Closed' }
  ],
  AttachmentType: [
    { text: '交易确认书', value: 'TradeConfirmation' },
    { text: '交易结算单', value: 'TradeSettlement' },
    { text: '保证金追保函', value: 'MarginCall' },
    { text: '每日交易估值单（盯市）', value: 'CustDailySettlement' },
    { text: '子客户每日结算单', value: 'SubCustDailySettlement' },
    { text: '上传附件', value: 'Upload' },
    { text: '客户月度结算单', value: 'CustMonthlySettlement' }
  ],
  IndexType: [
    { text: 'Price', value: 'Price' },
    { text: 'DeltaCash', value: 'DeltaCash' },
    { text: 'Delta', value: 'Delta' },
    { text: 'GammaCash', value: 'GammaCash' },
    { text: 'Gamma', value: 'Gamma' },
    { text: 'DailyTheta', value: 'DailyTheta' },
    { text: 'Vega', value: 'Vega' },
    { text: 'Rho', value: 'Rho' },
    { text: 'Vomma', value: 'Vomma' },
    { text: 'Vanna', value: 'Vanna' },
    { text: 'DeltaDecay', value: 'DeltaDecay' },
    { text: 'VegaDecay', value: 'VegaDecay' },
    { text: 'CrossGamma', value: 'CrossGamma' },
    { text: 'CrossVega', value: 'CrossVega' },
    { text: 'CorrelationDelta', value: 'CorrelationDelta' }
  ],
  LikedType: [
    { text: '期权', value: 'Option' },
    { text: '投资组合', value: 'InvestmentPortfolio' },
    { text: '板块', value: 'Plate' },
    { text: '标的', value: 'Underlying' }
  ],
  Plate: [
    { text: '农产品', value: 'Agriculture' },
    { text: '贵金属', value: 'NobleMetal' },
    { text: '有色', value: 'Coloured' },
    { text: '黑色', value: 'Black' },
    { text: '化工', value: 'Chemical' },
    { text: '股指', value: 'StockIndex' },
    { text: '债券', value: 'Bond' },
    { text: '权益类', value: 'Equity' },
    { text: 'A股', value: 'AShare' }
  ],
  SpecPlate: [
    { text: '农产品', value: 'Agriculture' },
    { text: '贵金属', value: 'NobleMetal' },
    { text: '有色', value: 'Coloured' },
    { text: '黑色+橡胶', value: 'Black' },
    { text: '化工', value: 'Chemical' },
    { text: '股指', value: 'StockIndex' },
    { text: '债券', value: 'Bond' },
    { text: '权益类', value: 'Equity' },
    { text: 'A股', value: 'AShare' }
  ],
  VolatilityType: [
    { text: 'EXCHANGE', value: 'EXCHANGE' },
    { text: 'OTC', value: 'OTC' }
  ],
  MarginAddReleaseStatus: [
    { text: '待处理', value: 'ToBeProcessed' },
    { text: '处理完成', value: 'CompleteProcessing' },
    { text: '放弃处理', value: 'Abandon' }
  ],
  CustStatus: [
    { text: '正常', value: 'Normal' },
    { text: '冻结', value: 'Frozen' }
  ],
  CustType: [
    { text: '其他', value: 'Other' },
    { text: '保险公司', value: 'Insurance' },
    { text: '券商', value: 'Brokerage' },
    { text: '风险管理公司', value: 'FuturesRisk' },
    { text: '银行', value: 'Bank' },
    { text: '信托计划产品', value: 'TrustPlan' },
    { text: '保险资管产品', value: 'InsuranceManage' },
    { text: '基金专户产品', value: 'SpecialFund' },
    { text: '银行理财产品', value: 'BankFinancing' },
    { text: '券商资管产品', value: 'SecuritiesManage' },
    { text: '公募基金管理人', value: 'PublicFund' },
    { text: '公募基金', value: 'PublicEquity' },
    { text: '私募基金管理人', value: 'PrivateFund' },
    { text: '私募基金', value: 'PrivateEquity' },
    { text: '一般投资公司', value: 'ConsultingCo' },
    { text: '实体产业客户', value: 'EntityIndustry' },
    { text: '机构', value: 'Institution' }
  ],
  CustVolume: [
    { text: '小', value: 'Small' },
    { text: '中', value: 'Middle' },
    { text: '大', value: 'Big' },
    { text: '特大', value: 'EspeciallyBig' }
  ],
  CustIndustry: [
    { text: '私募/投资公司', value: 'InvestmentCompany' },
    { text: '贸易商', value: 'Trafficker' },
    { text: '厂商', value: 'Manufacturer' },
    { text: '金融机构', value: 'FinancialInstitution' }
  ],
  TransactionMode: [
    { text: '投机', value: 'Speculation' },
    { text: '套保', value: 'Hedge' },
    { text: '收益增强', value: 'ProfitEnhancement' },
    { text: '买权', value: 'BuyRight' },
    { text: '卖权', value: 'SellRight' }
  ],
  TransactionStructure: [
    { text: '单边', value: 'Unilateral' },
    { text: '价差', value: 'Spread' },
    { text: '领口式', value: 'Neckline' },
    { text: '奇异', value: 'Strange' }
  ],
  AgentType: [
    { text: '指令下达人', value: 'InstructionsIssuedPeople' },
    { text: '结算单代理人', value: 'SettlementAgent' },
    { text: '委托代理人', value: 'EntrustAgent' },
    { text: '适当性授权代理人', value: 'SuitabilityAuthorizedAgent' },
    { text: '协议签署被授权人', value: 'OtcOpenPowerAgent' },
    { text: '交易委托代理人', value: 'OtcOpenAgentAgent' },
    { text: '适当性评估被授权人', value: 'OtcOpenSuitableAgent' }
  ],
  AgentStatus: [
    { text: '启用', value: 'Enable' },
    { text: '禁用', value: 'Disable' }
  ],
  AccountProgress: [
    { text: '未开户', value: 'Unopened' },
    { text: '开户过程中', value: 'Opening ' },
    { text: '已开户', value: 'Opened' }
  ],
  EntrustIdKind: [
    { text: '身份证', value: 'IDCard' },
    { text: '外国护照', value: 'ForeignPassport' },
    { text: '港澳居民来往内地通行证', value: 'MTPForHKAndMacaoResidents' },
    { text: '台湾居民来往大陆通行证', value: 'MTPForTWResidents' }
  ],
  AccountPassStatus: [
    { text: '新建', value: 'New' },
    { text: '待审批', value: 'PendingApproval' },
    { text: '审批中', value: 'Approving' },
    { text: '已通过', value: 'Passed' },
    { text: '拒绝', value: 'Refuse' },
    { text: '撤销审批', value: 'Cancel' }
  ],
  FlowDirection: [
    { text: '入金', value: 'In' },
    { text: '出金', value: 'Out' }
  ],
  CustKind: [
    { text: '普通投资者', value: 'OrdinaryInvestor' },
    { text: '专业投资者', value: 'ProfessionalInvestors' }
  ],
  CustLevel: [
    { text: 'C1', value: 'OneLevel' },
    { text: 'C2', value: 'TwoLevel' },
    { text: 'C3', value: 'ThreeLevel' },
    { text: 'C4', value: 'FourLevel' },
    { text: 'C5', value: 'FiveLevel' },
    { text: 'A类', value: 'A' },
    { text: 'B类', value: 'B' },
    { text: 'C类', value: 'C' }
  ],
  CustServiceLevel: [
    { text: 'R4', value: 'R4' },
    { text: 'R5', value: 'R5' }
  ],
  CustIntrOrExt: [
    { text: '外部客户', value: 'External' },
    { text: '内部客户', value: 'Internal' }
  ],
  SysStatus: [
    { text: '就绪', value: 'Ready' },
    { text: '正在结算中', value: 'UnderSettlement' }
  ],
  AuthorizationType: [
    { text: '法人代表授权书', value: 'LegalPersonAuthorization' },
    { text: '场外衍生品交易委托授权书', value: 'OtcTradeAuthorization' }
  ],
  TransactionPurpose: [
    { text: '投机', value: 'Speculation' },
    { text: '套保', value: 'Hedging' },
    { text: '含权交易', value: 'WeightedTransaction' },
    { text: '含权结算', value: 'ProfitAdjust' },
    { text: '融资交易', value: 'FinancingTransaction' },
    { text: '非报送合约', value: 'NonReportContract' },
    { text: '特殊项目', value: 'SpecialProject' }
  ],
  CompleteOrPart: [
    { text: '全部了结', value: 'Complete' },
    { text: '部分了结', value: 'Part' }
  ],
  ProcessStatus: [
    { text: '未处理', value: 'UnProcessed' },
    { text: '已丢弃', value: 'Discard' },
    { text: '已处理', value: 'Processed' }
  ],
  MarginRecordType: [
    { text: '期权', value: 'Option' },
    { text: '期货', value: 'Futures' },
    { text: '备兑期权', value: 'CoveredOption' }
  ],
  SettleType: [
    { text: '现金交割', value: 'CashDelivery' },
    { text: '期货交割', value: 'FuturesDelivery' }
  ],
  PayDirection: [
    { text: '买方赔付卖方', value: 'BuyToSell' },
    { text: '卖方赔付买方', value: 'SellToBuy' }
  ],
  QuoteType: [
    { text: '收盘价', value: 'ClosePrice' },
    { text: '结算价', value: 'SettlePrice' }
  ],
  SettlePricePickType: [
    { text: '全周期', value: 'Entire' },
    { text: '指定区间', value: 'Section' }
  ],
  CustParamType: [
    { text: '是否允许出金透支', value: 'IsOverdraftAllowed' },
    {
      text: '交易确认书和结算单是否使用老模版',
      value: 'IsConfAndStlUseOldTpl'
    },
    { text: '是否强制生成日度估值单', value: 'IsForceGenDailyEvalFile' },
    { text: '是否强制生成月度估值单', value: 'IsForceGenMonthlyEvalFile' },
    { text: '不进行电子签证', value: 'NoElectronicSign' },
    { text: '不计算初始保证金', value: 'NoCalcInitialMargin' },
    { text: '日度结算单发送不常用客户', value: 'NotDefaultSendDailyEvalFile' },
    {
      text: '月度结算单发送不常用客户',
      value: 'NotDefaultSendMonthlyEvalFile'
    },
    { text: '是否类同业客户', value: 'IsSimilarPeerCust' },
    {
      text: '是否生成定制雪球确认书与结算单',
      value: 'IsGenSpecifiedSnowballFile'
    },
    { text: '雪球包含特殊字句', value: 'IsSnowballSpecWords' }
  ],
  SendType: [
    { text: '交易确认书', value: 'TradeConfirmation' },
    { text: '交易结算单', value: 'TradeSettlement' },
    { text: '日度估值单', value: 'CustDailySettlement' },
    { text: '子客户每日结算单', value: 'SubCustDailySettlement' },
    { text: '月度估值单', value: 'CustMonthlySettlement' },
    { text: '保证金追保函', value: 'MarginCall' },
    { text: '标的除权除息通知', value: 'ContractMdfForXDNotice' }
  ],
  TemplateUserType: [
    { text: '用户', value: 'User' },
    { text: '角色', value: 'Roles' }
  ],
  IsChangePower: [
    { text: '正常审批', value: 'Original' },
    { text: '转授权审批', value: 'ChangePower' }
  ],
  CodeType: [
    { text: '品种', value: 'Varieties' },
    { text: '合约', value: 'Contract' }
  ],
  FundAccountType: [
    { text: '股票账户', value: 'StockAccount' },
    { text: '50ETF', value: 'ETF50Account' },
    { text: '特法账户', value: 'SpecialAccount' },
    { text: '锐斯得账户(外部)', value: 'RSDAccount' },
    { text: '新加坡掉期美元账户(外部)', value: 'SingaporeSwapAccount' },
    { text: '其他出入金', value: 'Others' },
    { text: '其他收付款', value: 'OthersPaymentAndReceived' }
  ],
  AutoPricingType: [
    { text: '普通', value: 'Normal' },
    { text: '敲出', value: 'Knockout' },
    { text: '固定赔付', value: 'FixedPayout' }
  ],
  UploadFileType: [
    { text: '客户附件', value: 'CustFile' },
    { text: '开仓附件', value: 'ContractOpenFile' },
    { text: '平仓附件', value: 'ContractCloseFile' }
  ],
  UserParamType: [
    { text: '是否允许登录时弹出提示信息', value: 'IsUserLoginTipInfo' }
  ],
  InvestorParamType: [
    { text: '场内期权是否加入Vanilla敞口统计', value: 'IsOptionInVanilla' },
    { text: '期货是否加入Vanilla敞口统计', value: 'IsFutuInVanilla' },
    { text: '仓位是否加入敞口统计', value: 'IsPositionInExposure' },
    { text: '价差期权类型对冲账户', value: 'PriceSpreadHedge' },
    { text: '香草类型对冲账户', value: 'VanillaHedge' },
    { text: '其他类型对冲账户', value: 'OtherHedge' }
  ],
  AutoPricingFutuCloseStatus: [
    { text: '未审批', value: 'New' },
    { text: '审批中', value: 'Approving' },
    { text: '已通过', value: 'Passed' },
    { text: '拒绝', value: 'Refuse' }
  ],
  ContractParamType: [
    { text: '不加入估值情况报表统计', value: 'NoEvaluationReporter' }
  ],
  MakeupContractTemType: [
    { text: '单腿期权', value: 'OneLegContract' },
    { text: '两腿期权', value: 'TwoLegContract' },
    { text: '三腿期权', value: 'ThreeLegContract' },
    { text: '四腿期权', value: 'FourLegContract' }
  ],
  SysParamType: [
    { text: '个股期权默认保证金', value: 'StockDefaultMarPercent' }
  ],
  StockSymbolBusinessStatus: [
    { text: '通过', value: 'Pass' },
    { text: '注销', value: 'Delete' },
    { text: '过期', value: 'Expires' }
  ],
  DailyLimitNum: [
    { text: '三个涨停', value: 'ThreeLimitUp' },
    { text: '两个涨停', value: 'TwoLimitUp' },
    { text: '一个涨停', value: 'OneLimitUp' },
    { text: '一个跌停', value: 'OneLimitDown' },
    { text: '两个跌停', value: 'TwoLimitDown' },
    { text: '三个跌停', value: 'ThreeLimitDown' }
  ],
  ContractProductStructure: [
    { text: '香草', value: 'VA' },
    { text: '风险逆转', value: 'RE' },
    { text: '三领口', value: 'CO' },
    { text: '跨式', value: 'STR' },
    { text: '宽跨式', value: 'STA' },
    { text: '价差组合', value: 'VE' },
    { text: '标的价差期权', value: 'SP' },
    { text: '远期', value: 'FW' },
    { text: '自动敲出可赎回-凤凰式', value: 'PA' },
    { text: '自动敲出可赎回-雪球', value: 'SA' },
    { text: '单鲨', value: 'SF' },
    { text: '二元', value: 'DI' },
    { text: '亚式', value: 'AS' },
    { text: '三层阶梯', value: 'TL' },
    { text: '二元凹式', value: 'DD' },
    { text: '二元凸式', value: 'DU' },
    { text: '双鲨', value: 'DSF' },
    { text: '区间累计', value: 'RA' },
    { text: '一触即付', value: 'OT' },
    { text: '双不触碰', value: 'DNT' },
    { text: '其他', value: 'O' }
  ],
  CurrencyType: [
    { text: '人民币', value: 'CNY' },
    { text: '美元', value: 'USD' },
    { text: '欧元', value: 'EUR' },
    { text: '澳元', value: 'AUD' },
    { text: '英镑', value: 'GBP' },
    { text: '港币', value: 'HKD' },
    { text: '日元', value: 'JPY' },
    { text: '新元', value: 'SGD' }
  ],
  TransferType: [
    { text: '划转', value: 'Transfer' },
    { text: '换汇', value: 'Exchange' }
  ],
  TrueFalseFlag: [
    { text: '是', value: 'True' },
    { text: '否', value: 'False' }
  ],
  KnockPriceSettleType: [
    { text: '万得软件全天均价', value: 'DailyAverage' },
    { text: '当日收盘价', value: 'DailyClose' },
    { text: '区间TWAP价格', value: 'TWAPAverage' },
    { text: '区间VWAP价格', value: 'VWAPAverage' }
  ],
  KnockType: [
    { text: '敲入', value: 'In' },
    { text: '敲出', value: 'Out' }
  ],
  ServerType: [
    { text: '融行', value: 'RohonOpt' },
    { text: '中信wcats', value: 'WcatsStock' }
  ],
  DepositCollectType: [
    { text: '比例收取', value: 'CollectByRatio' },
    { text: '固定金额', value: 'CollectByFixed' }
  ],
  AcctPassPurpose: [
    { text: '向客户支付保证金(出金)', value: 'PayCustMargin' },
    { text: '含权结算出入金', value: 'ProfitAdjust' },
    { text: '融资交易出入金', value: 'FinancingTransaction' },
    { text: '非报送合约出入金', value: 'NonReportContract' },
    { text: '其他', value: 'Other' }
  ],
  InvestorType: [
    { text: '内部自营', value: 'OwnBusiness' },
    { text: '香草对冲', value: 'VanillaAccount' },
    { text: '股指对冲', value: 'StockIndexAccount' },
    { text: '交易所项目对冲', value: 'ExchangeHedgeAccount' },
    { text: '奇异对冲', value: 'ExoticAccount' },
    { text: '自动点价对冲', value: 'AutoPriAccount' },
    { text: '股票', value: 'Stock' },
    { text: '外盘', value: 'Foreign' }
  ],
  AsianType: [
    { text: '普通亚式', value: 'NormalAsian' },
    { text: '普通增强亚式', value: 'NormalEnhanceAsian' }
  ],
  ObserveFreq: [
    { text: '每日观察', value: 'EveryDay' },
    { text: '到期观察', value: 'EndDay' }
  ],
  CustGlobalParamType: [{ text: '是否显示delta', value: 'DeltaFlag' }],
  StockProductType: [
    { text: 'A股', value: 'AShare' },
    { text: '基金', value: 'Fund' }
  ],
  RiskProductType: [
    { text: '商品香草', value: 'CommodityVanilla' },
    { text: '商品奇异', value: 'CommodityExotic' },
    { text: '权益香草', value: 'EquityVanilla' },
    { text: '权益奇异', value: 'EquityExotic' }
  ],
  AssetType: [
    { text: '利率', value: 'IR' },
    { text: '商品', value: 'CO' },
    { text: '信用', value: 'CR' },
    { text: '外汇', value: 'FX' },
    { text: '权益', value: 'EQ' }
  ],
  SensitiveEventType: [
    {
      text: '最近1年内单笔交易规模小于100W(不含)的交易品种超过5个',
      value: 'NotionalUnderlyingSensi'
    },
    {
      text: '最近1个月内交易规模小于100W(不含)的交易笔数大于30笔',
      value: 'NotionalOptionSensi'
    },
    { text: '最近两年内累计交易品种超过20个', value: 'TradeUnderlyingSensi' }
  ],
  RiskMonitorEventType: [
    { text: '客户敏感性事件', value: 'CustSensitiveEvent' },
    { text: '集中度预警事件', value: 'ConcentrateEvent' },
    { text: '风控指标事件', value: 'RiskIndexEvent' }
  ],
  InvestSerialType: [
    { text: '自营', value: 'OwnBusiness' },
    { text: '交易所项目', value: 'Project' },
    { text: '对冲', value: 'Hedge' },
    { text: '套利', value: 'Straddle' },
    { text: '特法项目', value: 'SpecProject' }
  ],
  ConcentrateEventType: [
    {
      text: '根据客户集中度，当前5位占比大于30%时进行预警提示',
      value: 'CustConcentrateWarn'
    },
    {
      text: '当单一挂钩股票标的占其总市值超过5%时',
      value: 'UnderlyingConcentrateWarn'
    },
    {
      text: '当个股场外衍生品存续规模超过净资产的20%时进行预警提醒',
      value: 'StockNotionalWarn'
    },
    { text: 'delta敞口超限', value: 'PlateDeltaExceedWarn' },
    { text: 'vega敞口超限', value: 'PlateVegaExceedWarn' }
  ],
  OtherSecurUserType: [
    { text: '何方舟套利', value: 'HeFangZhouArbitrage' },
    { text: '沈阳套利', value: 'ShenYangArbitrage' },
    { text: '金凤套利', value: 'JinfengArbitrage' }
  ],
  ApprovalBatchStatus: [
    { text: '审批中', value: 'OnApprove' },
    { text: '完成审批', value: 'CompleteApprove' },
    { text: '中止审批', value: 'TerminationApprove' },
    { text: '撤销审批', value: 'CancelApprove' }
  ],
  OptionCalType: [
    { text: '客户方', value: 'cust' },
    { text: '我方', value: 'self' }
  ],
  ChangeType: [
    { text: '修改合同开仓信息', value: 'ChangeContractOpen' },
    { text: '修改合同了结信息', value: 'ChangeContractClose' },
    { text: '删除合同了结信息', value: 'DeleteContractClose' },
    { text: '撤回开仓', value: 'WithdrawContractOpen' }
  ],
  VanillaOrExotic: [
    { text: '香草', value: 'Vanilla' },
    { text: '奇异', value: 'Exotic' }
  ],
  FixedPayType: [
    { text: '期货赔付', value: 'PayFutures' },
    { text: '金额赔付', value: 'PayCompensation' }
  ],
  DefrayDirection: [
    { text: '我方支付', value: 'SelfPay' },
    { text: '我方收取', value: 'SelfReceive' }
  ],
  SpecEvaCalMethod: [
    { text: '利率类特殊估值', value: 'RateSpecEva' },
    { text: '特殊线性估值', value: 'LinearSpecEva' },
    { text: '基差互换算法', value: 'BasisSpecEva' },
    { text: '不参与计算', value: 'NotJoinEva' }
  ],
  ReportSnowballType: [
    { text: '传统雪球', value: 'StockSnowball' },
    { text: '保底雪球', value: 'StockPromiseSnowball' },
    { text: '阶梯价雪球', value: 'StepPriceSnowball' },
    { text: '小雪球', value: 'SmallSnowball' },
    { text: '折价雪球', value: 'CutPriceSnowball' }
  ],
  KnockInOptionType: [
    { text: '香草看跌期权', value: 'VanillaPutOption' },
    { text: '香草看涨期权', value: 'VanillaCallOption' },
    { text: '熊市价差期权', value: 'BearMarketSpreadOption' },
    { text: '牛市价差期权', value: 'CowMarketSpreadOption' },
    { text: '其他', value: 'OtherOption' }
  ],
  SnowballWatchRate: [
    { text: '逐日', value: 'Daily' },
    { text: '每月（节日加后移）', value: 'MonthlyAfter' },
    { text: '每月（节日加前移）', value: 'MonthlyBefore' },
    { text: '其他', value: 'Other' }
  ],
  CouponRateUnit: [
    { text: '按日计息', value: 'Daily' },
    { text: '按月计息', value: 'Monthly' }
  ],
  FixedProfitType: [
    { text: '年化', value: 'ByYear' },
    { text: '绝对', value: 'ByFixed' }
  ],
  ExerciseType: [
    { text: '绝对', value: 'Absolute' },
    { text: '相对', value: 'Relative' },
    { text: '百分比', value: 'Percent' }
  ],
  MarketOrLimit: [
    { text: '市价', value: 'Market' },
    { text: '限价', value: 'Limit' }
  ],
  OrderStatus: [
    { text: '进行中', value: 'InExecution' },
    { text: '失败', value: 'Fail' },
    { text: '人工回复中', value: 'ManualRecovery' },
    { text: '结束', value: 'Finish' }
  ],
  AccountPassAppleStatus: [
    { text: '未通过', value: 'UnPass' },
    { text: '审批中', value: 'Approval' },
    { text: '已通过', value: 'Passed' },
    { text: '已提交', value: 'Submitted' },
    { text: '已驳回', value: 'Rejected' },
    { text: '已撤销', value: 'Revoked' }
  ],
  ContractAppleStatus: [
    { text: '已提交', value: 'Submitted' },
    { text: '待审批', value: 'WaitingApprove' },
    { text: '存续期', value: 'Duration' },
    { text: '已驳回', value: 'Rejected' },
    { text: '待提交', value: 'WaitingSubmit' },
    { text: '已了结', value: 'Finish' },
    { text: '未通过', value: 'UnPass' }
  ],
  ContractMateStatus: [
    { text: '待匹配', value: 'WaitingMate' },
    { text: '已匹配', value: 'Matched' }
  ],
  ContractAppleType: [
    { text: '个股香草', value: 'StockVanilla' },
    { text: '商品香草', value: 'CommodityVanilla' },
    { text: '其他合约', value: 'OtherContract' }
  ],
  ContractAppleObserveType: [
    { text: '无观察', value: 'None' },
    { text: '每月观察', value: 'Monthly' },
    { text: '前几个月不观察', value: 'UpMonths' }
  ],
  AutoOrderType: [
    { text: '香草看涨期权', value: 'Call' },
    { text: '香草看跌期权', value: 'Put' }
  ],
  BalanceFlowType: [
    { text: '商品', value: 'Commodity' },
    { text: '指数', value: 'Index' },
    { text: '个股', value: 'Stock' },
    { text: '混合', value: 'Mixed' },
    { text: '其他', value: 'Other' }
  ],
  InquiryStatus: [
    { text: '进行中', value: 'InExecution' },
    { text: '失败', value: 'Fail' },
    { text: '结束', value: 'Finish' }
  ],
  AutomatedStockType: [
    { text: '香草', value: 'Vanilla' },
    { text: '价差', value: 'Spread' }
  ]
}
export default {
  get (name) {
    return dictInfo[name]
  },
  text (name, value) {
    const ret = dictInfo[name]
      ? dictInfo[name].find(item => {
          return item.value === value
        })
      : null
    return ret ? ret.text : value
  }
}
